import { useQuery } from "@tanstack/react-query";
import type { GifProviderName } from "@atrium/shared";
import { api } from "../../lib/api";

export interface ServerConfig {
  maxImageMb: number;
  maxVideoMb: number;
  /** Null when no GIF provider is configured: hide the GIF picker. */
  gifs: { provider: GifProviderName } | null;
}

/** Public server configuration (cached for the session). */
export function useServerConfig() {
  return useQuery({
    queryKey: ["server-config"],
    queryFn: () => api.get<ServerConfig>("/api/config"),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}
